import { AboutMe } from "../components/AboutMe/AboutMe";

export function About() {
  return <AboutMe />;
}
